exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#add-patient-icon{max-width:150px;fill:#454545;-webkit-transition:fill .5s ease;transition:fill .5s ease}#add-patient-icon:hover{cursor:pointer;fill:#ff4961}h5{margin:15px 0 20px 0}", ""]);

